/**
 * 角色统计卡片配置
 */

export interface RoleStats {
  total: number;
  active: number;
  inactive: number;
}

/**
 * 创建统计卡片配置
 * @param roleStats 角色统计数据
 * @returns 统计卡片配置
 */
export const createStatisticConfig = (roleStats: RoleStats) => ({
  cards: [
    {
      key: "total",
      title: "总角色数",
      value: roleStats.total,
      color: "#1890ff",
    },
    {
      key: "active",
      title: "启用角色",
      value: roleStats.active,
      color: "#52c41a",
    },
    {
      key: "inactive",
      title: "禁用角色",
      value: roleStats.inactive,
      color: "#ff4d4f",
    },
  ],
});

// 统计面板布局配置（用于控制外层组件参数）
export const statisticLayoutConfig = {
  columns: 3,
  gutter: [16, 0] as [number, number], // 去掉底部额外间距，避免与容器 gap 叠加
};
